import React from 'react'

const InternalServerError = () => {
    return (<div>Something whent wrong, please contact the system administrator.</div>)
}

export default InternalServerError